module.exports = __webpack_public_path__ + "VIPV31.png?d6a2d97b65a4fcf2dd3d7b3ef488d79c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/horses/VIPV31.png
// module id = 127
// module chunks = 0